import { FC, ReactNode } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  CircularProgress,
} from '@material-ui/core';
import TablePaginationActions, { ITablePaginationActionsProps } from '../TableContent/Pagination';
import { useStyles } from './style';

interface Column {
  id: string;
  label: string;
  minWidth?: number;
  align?: 'left' | 'center' | 'right';
  format?: (value: any) => string | ReactNode;
}

interface IStatsTable {
  columns: Column[];
  data: any[];
  loading?: boolean;
  pagination?: ITablePaginationActionsProps;
  bgColor?: string;
}

const StatsTable: FC<IStatsTable> = ({
  columns,
  data,
  loading = false,
  pagination,
  bgColor = '#23296F',
}) => {
  const classes = useStyles({ bgColor });

  if (loading) {
    return (
      <div className={classes.loadingContainer}>
        <CircularProgress style={{ color: bgColor }} />
      </div>
    );
  }

  if (!data || data.length === 0) {
    return (
      <div className={classes.emptyContainer}>
        <Typography>Aucun résultat</Typography>
      </div>
    );
  }

  return (
    <div className={classes.root}>
      <TableContainer component={Paper} className={classes.tableContainer}>
        <Table className={classes.table} stickyHeader={true}>
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align || 'left'}
                  style={{ minWidth: column.minWidth }}
                  className={classes.headerCell}>
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row, rowIndex) => (
              <TableRow key={row.id || `row-${rowIndex}`} className={classes.bodyRow}>
                {columns.map((column) => {
                  const value = row[column.id];
                  const displayValue = column.format ? column.format(value) : value;
                  
                  return (
                    <TableCell
                      key={column.id}
                      align={column.align || 'left'}
                      className={classes.bodyCell}>
                      {displayValue}
                    </TableCell>
                  );
                })}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      
      {pagination && (
        <div className={classes.paginationContainer}>
          <TablePaginationActions
            count={pagination.count}
            page={pagination.page}
            rowsPerPage={pagination.rowsPerPage}
            onChangePage={pagination.onChangePage}
          />
        </div>
      )}
    </div>
  );
};

export default StatsTable;

